import {
  MODULE_METADATA_ERROR,
  MODULE_METADATA_REQUEST,
  MODULE_METADATA_SUCCESS,
} from "../../../actionTypes";
import { ModuleMetadataByIdSTORE, ModulesActionTypes } from "../../../types";
import moduleReducer from "./module";

const initialState: ModuleMetadataByIdSTORE = {};

const byId = (
  state = initialState,
  action: ModulesActionTypes
): ModuleMetadataByIdSTORE => {
  switch (action.type) {
    case MODULE_METADATA_ERROR:
    case MODULE_METADATA_REQUEST:
    case MODULE_METADATA_SUCCESS: {
      const moduleId = action.payload.id;

      return {
        ...state,
        [moduleId]: moduleReducer(state[moduleId], action),
      };
    }
    default:
      return state;
  }
};

export default byId;
